import { createUseStyles } from '@glu/theming';

const styles = () => ({
  ordinalSelect: {
    width: 90,
    display: 'inline-block'
  },
  intervalTypeSelect: {
    width: 'calc(100% - 100px)',
    display: 'inline-block',
    marginLeft: 10
  },
  datePicker: {
    display: 'inline-block',
    width: props => (
      props.canSetTime
        ? props.timePicker24Hour
          ? props.showingMultipleDays
            ? 'calc(100% - 135px)'
            : 'calc(100% - 86px)'
          : props.showingMultipleDays
            ? 'calc(100% - 201px)'
            : 'calc(100% - 161px)'
        : props.showingMultipleDays
          ? 'calc(100% - 40px)'
          : '100%'
    ),
    paddingRight: props => (
      props.canSetTime || props.showingMultipleDays ? 10 : 0
    )
  },
  timePicker: {
    display: 'inline-block'
  }
});

export default createUseStyles(styles);
